define((require) => {
    "use strict";

    var ImprovedView                   = require("zbone/ImprovedView"),
        ReactBridge                    = require("backbone.react-bridge"),
        ZmagsUiLibrary                 = require("@zmags/zmags-ui-library"),
        MsCompanyCollection            = require("ui/experienceOverview/experiencePermissions/MsCompanyCollection"),
        DropdownValueMapper            = require("ui/experienceOverview/experiencePermissions/DropdownValueMapper"),
        DropdownOnChangeHandlers       = require("ui/experienceOverview/experiencePermissions/DropdownOnChangeHandlers"),
        Permissions                    = require("shared/security/Permissions"),
        LoggedIn                       = require("shared/security/LoggedIn"),
        SharedEntityType               = require("ui/experienceOverview/experiencePermissions/SharedEntityType"),
        LoggedInUserState              = require("shared/ui/user/LoggedInUserState"),
        template                       = require("ui/experienceOverview/experiencePermissions/UserSharingPermissionsView.tpl");


    /**
     * Sub view used by the <tt>QuickView</tt> for displaying experience permissions.
     *
     * @class UserSharingPermissionsView
     */
    return ImprovedView.extend({

        template: template,

        regions: {
            dropdown: ".dropdown",
            checkboxRegion: ".checkbox-region"
        },

        group: null,

        templateHelpers: function() {
            return {
                userPermissionsEnabled: LoggedInUserState.get("companySettings").get("userPermissionsEnabled")
            };
        },

        initialize() {
            this.group = this.options.group;
            this.model = this.options.model;
        },

        onShow() {
            this.buildDropdown().then((dropdownComponent) => {
                this.dropdown.show(dropdownComponent);
            }).then(() => {
                return this.buildCheckbox();
            }).then((checkboxComponent) => {
                this.checkboxRegion.show(checkboxComponent);
            });
        },

        _resolveCheckboxData(sharedEntityResponse) {
            return sharedEntityResponse.get("sharedWithAll");
        },

        buildCheckbox: function() {
            const {model} = this;
            return model.fetch().then((sharedEntityResponse) => {
                let sharedWithAll = this._resolveCheckboxData(sharedEntityResponse);
                model.set("sharedWithAll", sharedWithAll);
                let sharedEntityOnChangeSharedWithAllHandler = model.onChangeSharedWithAllHandler.bind(model);
                return this._createCheckbox(sharedWithAll, sharedEntityOnChangeSharedWithAllHandler);
            });
        },

        _createCheckbox: function(sharedWithAll, onChangeSharedWithAllHandler) {
            const role = LoggedIn.principal().get("user").get("role").name;
            const isNotManager = role !== Permissions.Roles.MANAGER.name;
            return ReactBridge.viewFromComponent(ZmagsUiLibrary.CheckBox, {
                props: {
                    label: "Share experiences with all?",
                    checked: sharedWithAll,
                    disabled: isNotManager,
                    onChange: onChangeSharedWithAllHandler
                }
            });
        },

        buildDropdown: function() {
            const {model} = this;

            const companyCollection = new MsCompanyCollection(null, {
                companyId: model.get("companyId")
            });

            return companyCollection.fetch().then(() => {
                return this._getSharedEntity().then((sharedEntity) => {
                    const fixedUsers = DropdownValueMapper.mapUsersToFixedDropdownValues(companyCollection.models, model.get("createdBy"));
                    const dropdownUsers = this._getDropdownValues(companyCollection, sharedEntity, fixedUsers);
                    return this._createDropdownComponent(fixedUsers, dropdownUsers);
                });
            });
        },

        _createDropdownComponent: function(fixedUsers, dropdownUsers) {
            const dropdownHandler = new DropdownOnChangeHandlers({
                fixedValues: fixedUsers,
                model: this.model
            });

            const scopedGetProps = ({model}) => {
                const role = LoggedIn.principal().get("user").get("role").name;
                const isNotManager = role !== Permissions.Roles.MANAGER.name;
                return {
                    isDisabled: isNotManager || model.get("sharedWithAll")
                };
            };

            const dropdownComponent = ReactBridge.viewFromComponent(ZmagsUiLibrary.Dropdown, {
                model: this.model,
                observe: {
                    model: "change:sharedWithAll"
                },
                props: {
                    values: dropdownUsers,
                    fixedValues: fixedUsers,
                    onChange: dropdownHandler.onChangeHandler.bind(dropdownHandler)
                },
                getProps: scopedGetProps
            });
            return dropdownComponent;
        },

        _getSharedEntity: function() {
            const {model} = this;
            return model.fetch({}, {url: model.getURL()});
        },

        _getDropdownValues: function(companyCollection, model, fixedUsers) {
            const isNew = !model.get("version") && !model.get("editedBy");
            if (isNew) {
                this._createAndSaveSharedEntity(companyCollection, fixedUsers);
            }
            return DropdownValueMapper.mapUsersToDropdownValues({
                usersInCompany: companyCollection.models,
                entitySharedUsers: model.get("usersSharedWith"),
                entityCreator: model.get("createdBy")
            });
        },

        _getNoneFixedUsers(users, fixedUsers) {
            const notFixedUsers = users.filter((user) => {
                return fixedUsers.some((fixedUser) => !(fixedUser.value === user.get("id")));
            }).map((user) => user.get("id"));
            return notFixedUsers;
        },

        _createAndSaveSharedEntity(companyCollection, fixedUsers) {
            const {model, group} = this;
            const entityID = model.get("entityId");
            const isGroup = group ? SharedEntityType.GROUP : SharedEntityType.EXPERIENCE;

            model.set("entityId", entityID);
            model.set("entityType", isGroup);
            // TODO: update to check Company level data
            model.set("sharedWithAll", true);
            const usersSharedWith = this._getNoneFixedUsers(companyCollection.models, fixedUsers);
            model.set("usersSharedWith", usersSharedWith);

            return model.save({}, {url: model.postURL()});
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/experiencePermissions/UserSharingPermissionsView.js